import React from 'react'
import Grid, { FlexCell } from '@integec/grid-tools'
import { strCol, dateTimeCol, numCol } from '@integec/grid-tools/lib/cols'
import flexGridRenderer, {
  defaultCellRenderer,
} from '@integec/grid-tools/lib/flexRenderer'
import * as R from 'ramda'
import {
  getApiTargetInfo,
  getCauseCodeMap,
  getCauseCodeOmcMap,
} from 'core/selectors'
import { Menu, Dropdown } from 'antd'
import { GenericModal } from 'core'
import CardsErrorDialog from 'card-data/CardErrorDialogAntd'
import { formatData, extractData } from '@integec/grid-tools/lib//utils'

import { connect } from 'react-redux'
import { deleteCard97 } from 'api/pgads'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'

import {
  BasicColHeader,
  SortIndicator,
} from '@integec/grid-tools/lib/Components'
import { BROOKFIELD_CLIENT, WEE_CLIENT } from 'client'

export const ColHeader = BasicColHeader.extend`
  flex: 0 0 ${props => props.width}px;
  width: ${props => props.width}px;
  max-width: ${props => props.width}px;
`

const defaultColHeaderRenderer = ({ header, sortOrder, width, ...rest }) => (
  <ColHeader
    width={width}
    {...rest}
    sortable={header.sortable}
    isHeader={false}
    style={{
      backgroundColor: '#eee',
      color: '#333',
      fontSize: '0.85em',
      fontWeight: 'normal',
      width: header.ident === 'description' ? '90%' : undefined,
    }}
  >
    {header.display}
    {sortOrder === 'asc' ? (
      <SortIndicator>&#x25b2;</SortIndicator>
    ) : sortOrder === 'desc' ? (
      <SortIndicator>&#x25bc;</SortIndicator>
    ) : null}
  </ColHeader>
)

class TmpCard97 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedRows: [],
      promptNew: false,
      selectionInfo: {},
      mode: 'V',
    }
    //  = ({ data, screenSize, causeCodeMap }) =>
    this.selectionChange = this.selectionChange.bind(this)
    this.setPrompt = this.setPrompt.bind(this)
    // this.setPromptMsg = this.setPromptMsg.bind(this)
    // this.convertDataHeader = this.convertDataHeader.bind(this)
    this.doRemove = this.doRemove.bind(this)
    this.onDoubleClick = this.onDoubleClick.bind(this)
    this.onClick = this.onClick.bind(this)
    this.getSelectedRowIndex = this.getSelectedRowIndex.bind(this)
  }

  setEditMode(mode) {
    this.setState({ mode })
  }

  onDoubleClick() {
    // this.setState({ mode: 'V', promptNew: true })
    const { selectedRows } = this.state

    this.props.setCardEditPromptMode('V')

    this.props.setCardEditPromptRowData({
      ...selectedRows[0],
      unit: selectedRows[0].utility + selectedRows[0].unit,
    })
    this.props.setCardEditPrompt(true)
  }

  onClick(data, rowIndex) {
    this.props.setSelectedEventNum(data[rowIndex].eventNum)
  }

  cellRenderer = prop => {
    const {
      rowIndex,
      header,
      width,
      data,
      // display,
      isSelected,
    } = prop
    const value = extractData({ header, rowData: data[rowIndex] })
    const display = formatData({ header, value, rowData: data[rowIndex] })
    if (
      //! isSelected &&
      header.ident === 'causeCode' &&
      header.display === 'Cause' &&
      value !== undefined
    ) {
      const isOmc = this.props.causeCodeOmcMap[display]
      return (
        <FlexCell
          // width={header.ident.toLowerCase().includes('con') ? '30px': width}
          width={width}
          fontSize="small"
          style={{
            // fontSize: 'small',
            // height: '15px',
            backgroundColor: isOmc
              ? 'rgb(255,128,64,0.5)'
              : display >= 9180 && display <= 9199
              ? 'rgb(194,57,237,0.5)'
              : undefined,
            color: isSelected && isOmc ? 'black' : undefined,
          }}
          onDoubleClick={this.onDoubleClick}
          // onClick={e => this.onClick(data, rowIndex)}
          {...prop}
        >
          {data[rowIndex][header.ident]}
        </FlexCell>
      )
    }
    return defaultCellRenderer({
      ...prop,
      onDoubleClick: this.onDoubleClick,
      // onClick: e => this.onClick(data, rowIndex),
    })
  }

  renderFlex(screenSize) {
    return flexGridRenderer({
      headerRowHeight: 20,
      width: screenSize.width,
      height: screenSize.height - 10,
      // minHeight: '100%',
      autoFixColByKey: true,
      // fixedColCount: 1,
      fixedScrollHeightAdjustment: 1,
      colHeaderRenderer: defaultColHeaderRenderer,
      gridRenderProps: { getSelectionInfo: this.getSelectedRowIndex() },
      cellRenderer: this.cellRenderer,
      noDataRender: defaultNoDataRender,
    })
  }

  getSelectedRowIndex() {
    // let { eventNum } = this.props.graphSelBar
    // if (eventNum === undefined) return {}
    // let idx = this.props.data.findIndex(data => data.eventNum == eventNum)
    // let d = this.props.data.find(data => data.eventNum == eventNum)
    // //this.selectionChange({ selectedRows: [d] })
    // return { y1: idx, y2: idx, x1: 0, x2: headers.length }
  }

  setPrompt(open) {
    this.setState({ promptNew: open })
  }

  selectionChange = ({ selectedRows }) => {
    this.setState({ selectedRows })
  }

  setPromptMsg = (m, d) => {
    this.setState({
      promptMsg: m,
      promptNew: d,
      loading: false,
      errorPrompt: false,
    })
  }

  closeErrorPrompt = () => {
    this.setState({ errorPrompt: false, promptMsg: undefined, loading: false })
  }

  convertDataHeader(rd) {
    return {
      utility: rd,
    }
  }

  doRemove() {
    const { targetInfo } = this.props
    this.setState({ confirmRemove: false, loading: true })
    let delData = [this.state.selectedRows[0]]
    delData = delData.map(d => ({ ...d, unit: d.utility + d.unit }))
    deleteCard97(targetInfo)(delData).fork(this.setErr, data => {
      if (data.length > 0) {
        const onlyWarning = data.every(d => d.severity === 0)
        this.setState({
          loading: false,
          errors: data,
          onlyWarning,
          errorPrompt: true,
          action: 'delete',
        })
      } else {
        this.setPromptMsg('Data deleted successfully.', false)
      }
    })
  }

  confirmRemove = _ => this.setState({ confirmRemove: true })
  cancelRemove = () => this.setState({ confirmRemove: false })

  setOMCColor = _ => {
    // Color omcColor = new Color(255, 128, 64);
    // Color internalColor = new Color(194, 57, 237);
    // if (info == null) return Color.white;
    // if (info.isOMC())
    //     return omcColor;
    // if (info.isInternalCauseCode())  cause >= 9180 && cause <= 9199;
    //     return internalColor;
    // return Color.white;
  }

  render() {
    const {
      screenSize,
      causeCodeMap,
      data,
      card97Dominant,
      retrieveData,
      lock = 'U',
      envConfig,
      actionPermits,
    } = this.props
    const { selectedRows, promptMsg, errorPrompt } = this.state
    const { width, height } = screenSize
    const { authGodMode } = envConfig

    const hasPermissionForCard97 = hasAccesPermits({
      authGodMode,
      actionPermits,
      eventActions: [ScreenPermissions.CARD97_ADMIN],
      matchAny: true,
    })

    const headerWithFormatter = headers(
      card97Dominant
        ? parseInt(this.props.hoursWidth)
        : parseInt(this.props.hoursWidth) + 50,
      this.props.CLIENT,
      this.props.showShortName || false,
      screenSize.width
    )
      .map(header =>
        header.display === 'Cause Description'
          ? {
              ...header,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => causeCodeMap[value] || value,
            }
          : header
      )
      .filter(h => (h.ident !== 'dom' ? true : card97Dominant))

    //    const selectedRowsUnits = selectedRows.map(d => ({ ...d, unit: d.utility + d.unit }))
    return (
      <div
        style={{
          gridColumnEnd: 'span 1',
          // overflowX: 'auto',
          // width: this.props.screenSize.width,
          // maxWidth: this.props.screenSize.width,
          //   display: 'grid',
          // gridTemplateColumns: '0.98fr',
          // overflow: 'auto',
          // height,
          height: screenSize.height,
        }}
        onContextMenu={e => e.preventDefault()}
      >
        {/* <FullHeightSizer heightOffset={600}>
          {({ height, width }) => ( */}

        <Dropdown
          overlay={
            <Menu
              onClick={({ key }) => {
                this.setState({ mode: key })

                this.props.setCardEditPromptMode(key)

                const rd =
                  key === 'E' || key === 'D' || key === 'V'
                    ? {
                        ...selectedRows[0],
                        unit: selectedRows[0].utility + selectedRows[0].unit,
                      }
                    : {
                        utility: this.props.utility,
                        unit: this.props.unit,
                        year: this.props.selectedMonthYear.format('YYYY'),
                        conCode: '1',
                      }

                this.props.setCardEditPromptRowData(rd)
                this.props.setCardEditPrompt(true)
              }}
            >
              <Menu.Item key="V" disabled={selectedRows.length <= 0}>
                View
              </Menu.Item>
              {hasPermissionForCard97 && lock !== 'L' && (
                <Menu.Item
                  key="E"
                  disabled={
                    lock === 'L' ||
                    !hasPermissionForCard97 ||
                    selectedRows.length <= 0
                  }
                >
                  Update
                </Menu.Item>
              )}
              {hasPermissionForCard97 && lock !== 'L' && <Menu.Divider />}
              {hasPermissionForCard97 && lock !== 'L' && (
                <Menu.Item
                  key="N"
                  disabled={lock === 'L' || !hasPermissionForCard97}
                >
                  Insert
                </Menu.Item>
              )}
              {hasPermissionForCard97 && lock !== 'L' && <Menu.Divider />}
              {hasPermissionForCard97 && lock !== 'L' && (
                <Menu.Item
                  key="D"
                  disabled={
                    lock === 'L' ||
                    !hasPermissionForCard97 ||
                    selectedRows.length <= 0
                  }
                >
                  Delete
                </Menu.Item>
              )}
            </Menu>
          }
          trigger={['contextMenu']}
          // visible={this.state.visibleMenu || false}
        >
          <div
            style={{
              overflow: 'hidden',
              marginTop: '10px',
            }}
          >
            <Grid
              ref={this.props.cref}
              headers={headerWithFormatter}
              // data={dataCauseDesc}
              data={data}
              render={this.renderFlex({ width, height })}
              onSelectionChange={this.selectionChange}
              selectedRows={this.state.selectedRows}
              selectionType="row"
              selectionMode="single"
              manualSelection={view => this.getSelectedRowIndex(view)}
              // initialSortOptions={[
              //   { ident: 'shortName', sortOrder: 'asc' },
              //   { ident: 'eventStart', sortOrder: 'asc' },
              //   { ident: 'eventEnd', sortOrder: 'asc' },
              //   // { ident: 'year', sortOrder: 'asc' },
              //   { ident: 'eventNum', sortOrder: 'asc' },
              // ]}
              initialSortOptions={headerWithFormatter}
              altBy={u => u.unitId + u.shortName}
              altBgColor="#ebebeb"
            />
          </div>
        </Dropdown>

        {promptMsg && (
          <GenericModal
            key="msg1"
            title="Message"
            size="small"
            open
            onClose={() => {
              this.setState(
                _ => ({
                  promptMsg: undefined,
                  errorPrompt: undefined,
                  promptNew: undefined,
                  loading: false,
                }),
                retrieveData
              )
            }}
          >
            {() => promptMsg}
          </GenericModal>
        )}
        {errorPrompt && (
          <CardsErrorDialog
            keys="card97errordialog"
            errors={this.state.errors}
            onlyWarning={this.state.onlyWarning}
            closeErrorPrompt={this.closeErrorPrompt}
            action="save"
            setPromptMsg={this.setPromptMsg}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  causeCodeOmcMap: getCauseCodeOmcMap(state),
  causeCodeMap: getCauseCodeMap(state),
})

/* eslint-disable no-unused-vars */
export const headers = (width, CLIENT, showShortName, screenwidth) => {
  const hd = [
    dateTimeCol({
      ident: 'eventStart',
      display: 'Start',
      // displayFormat: 'MM/DD/YYYY HH:MI:SS',
      displayFormat: 'MM/DD/YYYY HH:mm',
      width: 150,
      sortOrder: 'asc',
    }),
    dateTimeCol({
      ident: 'eventEnd',
      display: 'End',
      width: 150,
      displayFormat: 'MM/DD/YYYY HH:mm',
      sortOrder: 'asc',
    }),
    strCol({
      ident: 'eventType',
      display: 'Type',
      width: 50,
    }),
    strCol({
      ident: 'eventNum',
      display: 'Event #',
      width: 70,
    }),
    strCol({
      ident: 'availCap',
      display: 'Avail MW',
      width: 70,
    }),
    strCol({
      ident: 'dom',
      display: 'Dom.',
      width: 50,
    }),
    strCol({
      ident: 'causeCode',
      display: 'Cause',
      width: 70,
    }),
    strCol({
      ident: 'causeDescription',
      display: 'Cause Description',
      width: 250,
      alignment: 'left',
      ellipsis: true,
    }),
  ]
  // const desc = strCol({
  //   ident: 'description',
  //   display: 'Description',
  //   // width: this.props.screenSize.width - 1000,
  //   // width: width - hd.map(a => a.width).reduce((a, b) => a + b),
  //   // width: 100 + width - hd.map(a => a.width).reduce((a, b) => a + b), // vertical scroll is the issue
  //   width: 400,
  //   alignment: 'left',
  //   ellipsis: true,
  // })

  const WEline = numCol({
    ident: 'line',
    display: 'Duration (HRS)',
  })

  const BKFline = numCol({
    ident: 'line',
    display: 'Spill MHH',
  })
  const shorName = strCol({
    ident: 'shortName',
    display: 'Short Name',
    sortOrder: 'asc',
  })

  let newColumn = showShortName ? [shorName, ...hd] : hd
  if (CLIENT === WEE_CLIENT) newColumn = R.insert(2, WEline, newColumn)
  else if (CLIENT === BROOKFIELD_CLIENT)
    newColumn = R.insert(5, BKFline, newColumn)

  const wd =
    screenwidth -
    newColumn.map(a => a.width || 100).reduce((a, b) => a + b) -
    50
  const desc = strCol({
    ident: 'description',
    display: 'Description',
    // width: this.props.screenSize.width - 1000,
    // width: width - hd.map(a => a.width || 100).reduce((a, b) => a + b),
    // width: 100 + width - hd.map(a => a.width || 100).reduce((a, b) => a + b), // vertical scroll is the issue
    //  width: 400,
    width: wd < 100 ? 100 : wd,
    alignment: 'left',
    ellipsis: true,
  })

  return [...newColumn, desc]
}

const defaultNoDataRender = ({ top, width, height }) => (
  <div
    style={{
      position: top > 0 ? 'absolute' : undefined,
      left: '0px',
      top,
      height: `${height}px`,
      width: `${width}px`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '2.5em',
      color: '#999',
      borderLeft: '3px dashed #ddd',
      borderRight: '3px dashed #ddd',
      borderBottom: '3px dashed #ddd',
      borderBottomRightRadius: '6px',
      borderBottomLeftRadius: '6px',
    }}
  >
    No Event Data for this Month
  </div>
)

export default connect(mapStateToProps)(TmpCard97)
